export const formatNumber = (num?: number) =>
  num && num.toLocaleString('en', { useGrouping: true });
